import { render, staticRenderFns } from "./AncillaryReissueSearchLegBodyCard.vue?vue&type=template&id=6b087210&scoped=true"
import script from "./AncillaryReissueSearchLegBodyCard.vue?vue&type=script&lang=js"
export * from "./AncillaryReissueSearchLegBodyCard.vue?vue&type=script&lang=js"
import style0 from "./AncillaryReissueSearchLegBodyCard.vue?vue&type=style&index=0&id=6b087210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b087210",
  null
  
)

export default component.exports